import { Pipe, PipeTransform } from '@angular/core';
import { ProductFeePayment } from '@src/app/features/web-submission/enums/product-fee-payment.enum';

@Pipe({
  name: 'productFeePaymentPipe',
})
export class ProductFeePaymentPipe implements PipeTransform {
  transform(value: ProductFeePayment): string {
    switch (value) {
      case ProductFeePayment.COMMENCEMENT:
        return 'Charged at Commencement Date';
      case ProductFeePayment.MONTHLY:
        return 'Monthly';
      case ProductFeePayment.YEARLY:
        return 'Yearly';
    }
  }
}
